// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro", "Helvetica Neue", Arial, sans-serif',
  },

  palette: {
    mode: "light",
    primary: { main: "#1976D2" },
    secondary: { main: "#0D47A1" },
    background: {
      default: "#F2F2F2", // whole page bg
      paper: "#FFFFFF",
    },
  },

  shape: { borderRadius: 10 },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F2F2F2",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          border: "1px solid rgba(25,118,210,0.15)",
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          border: "1px solid rgba(25,118,210,0.12)",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 10,
          fontWeight: 700,
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#1976D2",
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          color: "#fff",
          fontWeight: 800,
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          overflow: "hidden",
          border: "1px solid rgba(25,118,210,0.15)",
          "&:before": { display: "none" },
        },
      },
    },

    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(25,118,210,0.07)",
          borderBottom: "1px solid rgba(25,118,210,0.12)",
        },
      },
    },
  },
});

export default theme;
